import React from 'react';

export default function IconFinancials() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.6667 14.6668H3.33341C2.96675 14.6668 2.66675 14.3668 2.66675 14.0002V2.00016C2.66675 1.6335 2.96675 1.3335 3.33341 1.3335H9.44675C9.80008 1.3335 10.1401 1.4735 10.3867 1.72683L12.9401 4.28016C13.1934 4.5335 13.3334 4.86683 13.3334 5.22016V14.0002C13.3334 14.3668 13.0334 14.6668 12.6667 14.6668Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 1.45312V3.99979C10 4.36646 10.3 4.66646 10.6667 4.66646H13.2133"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 12V7"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 12V10"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 12V9"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
